import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
    Input,
    Row,
    Card,
    Form,
    Statistic,
    Col,
    Divider,
    Spin,
    Table,
    Typography,
    Layout,
    Collapse,
    Select,
    DatePicker,
    InputNumber,
    Button,
    Modal,
    Tooltip,
    List,
} from "antd";
import {
    PlusOutlined,
    DeleteOutlined,
    DownloadOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import CustomButton from "../../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import {
    apiConfig,
    labelConfig,
    staticConfig,
} from "../../../../group.config";
import dayjs from "dayjs";
import { accountStatus } from "../../../../../../components/facilities/AccountFacility";
import styles from "../../../../../../assets/styles/styles";

const { TextArea } = Input;
const { Content } = Layout;
const { Panel } = Collapse;

const ModifyApplication = (props) => {
    //DECLARED VARIABLES
    const { userData } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const [useForm] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const { Text, Title } = Typography;
    const isLienAllowed = Form.useWatch("lienAllowed", useForm);
    const isOverdraftAllowed = Form.useWatch("allowOverdraft", useForm);
    // const [isOverdraftAllowed, setIsOverdraftAllowed] = useState();

    const [templateProdDetail, setTemplateProdDetail] = useState({});

    // CHARGES FORM REQURED VARIABLES
    const [chargeTableCount, setChargeTableCount] = useState(0);
    const [chargeTableSource, setChargeTableSource] = useState([]);

    // ENDPOINT DECLARED VARIABLES
    const [productData, setProductData] = useState([]);
    const [fieldOfficerData, setFieldOfficerData] = useState([]);
    const [currencyData, setCurrencyData] = useState({});
    const [
        interestCompoundingPeriodTypeOptions,
        setInterestCompoundingPeriodTypeOptions,
    ] = useState([]);
    const [
        interestPostingPeriodTypeOptions,
        setInterestPostingPeriodTypeOptions,
    ] = useState([]);
    const [interestCalculationTypeOptions, setInterestCalculationTypeOptions] =
        useState([]);
    const [
        interestCalculationDaysInYearTypeOptions,
        setInterestCalculationDaysInYearTypeOptions,
    ] = useState([]);
    const [
        lockinPeriodFrequencyTypeOptions,
        setLockinPeriodFrequencyTypeOptions,
    ] = useState([]);
    const [charges, setCharges] = useState([]);
    const [chargesOptions, setChargesOptions] = useState([]);
    const [fieldOfficerIsEmpty, setFieldOfficerIsEmpty] = useState();

    // DECLARED VARIABLES FOR CHARGES FORM
    const [chargesValue, setChargesValue] = useState(null);
    const [chargeList, setChargeList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        customerInfo: null,
        customerAddressInfo: null,
    });

    useEffect(() => {
        getProductTemplate(state);
    }, []);

    const getProductTemplate = (state) => {
        const params = {
            associations: "charges",
            staffInSelectedOfficeOnly: true,
            template: true,
        };

        const url = `${apiConfig.SavingsAccounts}/${state.id}`;

        let body = {
            session,
            params,
        };
        setIsLoading(true);

        /** FETCH ROLE */
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            } else {
                const objList = res;
                setTemplateProdDetail(objList);
                let tempProducts = [];
                let tempFieldOfficer = [];
                let tempFunds = [];
                let tempCurrency = objList?.currency;
                let tempInterestCompoundingPeriodTypeOptions = [];
                let tempInterestPostingPeriodTypeOptions = [];
                let tempInterestCalculationTypeOptions = [];
                let tempInterestCalculationDaysInYearTypeOptions = [];
                let tempLockinPeriodFrequencyTypeOptions = [];
                let tempPeriodFrequencyTypeOptions = [];
                let tempPreClosurePenalInterestOnTypeOptions = [];
                let tempTaxGroupOptions = [];
                let tempAssetOptions = [];
                let tempEquityOptions = [];
                let tempExpenseOptions = [];
                let tempIncomeOptions = [];
                let tempLiabilityOptions = [];
                let tempCharges = [];
                let tempChargesOptions = [];
                let tempPenaltyOptions = [];
                let tempPaymentTypeOptions = [];

                // SHOW THE SAVED DATA
                useForm.setFieldsValue({
                    productId: objList.savingsProductId,
                    fieldOfficerId: objList.fieldOfficerId < 1 ? undefined : objList.fieldOfficerId,
                    submittedOnDate: objList?.timeline
                        ? dayjs(BOM.FormatArrayDate(objList?.timeline?.submittedOnDate))
                        : objList?.timeline?.submittedOnDate,
                    nominalAnnualInterestRate: objList?.nominalAnnualInterestRate,
                    interestCompoundingPeriodType:
                        objList?.interestCompoundingPeriodType?.id,
                    interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
                    interestCalculationType: objList?.interestCalculationType?.id,
                    interestCalculationDaysInYearType:
                        objList?.interestCalculationDaysInYearType?.id,
                    minRequiredOpeningBalance: objList?.minRequiredOpeningBalance,
                    lockinPeriodFrequency: objList?.lockinPeriodFrequency,
                    lockinPeriodFrequencyType: objList?.lockinPeriodFrequencyType?.id,
                    lienAllowed: objList?.lienAllowed,
                    maxAllowedLienLimit: objList?.maxAllowedLienLimit,
                    enforceMinRequiredBalance: objList?.enforceMinRequiredBalance,
                    minRequiredBalance: objList?.minRequiredBalance,
                    withdrawalFeeForTransfers: objList?.withdrawalFeeForTransfers,
                    allowOverdraft: objList?.allowOverdraft,
                });

                objList?.productOptions?.forEach((element) => {
                    tempProducts.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.fieldOfficerOptions?.forEach((element) => {
                    tempFieldOfficer.push({
                        value: element.id,
                        label: element.displayName,
                    });
                });

                objList?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
                    tempInterestCompoundingPeriodTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.interestPostingPeriodTypeOptions?.forEach((element) => {
                    tempInterestPostingPeriodTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.interestCalculationTypeOptions?.forEach((element) => {
                    tempInterestCalculationTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.interestCalculationDaysInYearTypeOptions?.forEach(
                    (element) => {
                        tempInterestCalculationDaysInYearTypeOptions.push({
                            value: element.id,
                            label: element.value,
                        });
                    }
                );
                objList?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
                    tempLockinPeriodFrequencyTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.periodFrequencyTypeOptions?.forEach((element) => {
                    tempPeriodFrequencyTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
                    tempPreClosurePenalInterestOnTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.taxGroupOptions?.forEach((element) => {
                    tempTaxGroupOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });
                objList?.accountingMappingOptions?.assetAccountOptions?.forEach(
                    (element) => {
                        tempAssetOptions.push({
                            value: element.id,
                            label: element.name,
                        });
                    }
                );
                objList?.accountingMappingOptions?.equityAccountOptions?.forEach(
                    (element) => {
                        tempEquityOptions.push({
                            value: element.id,
                            label: element.name,
                        });
                    }
                );
                objList?.accountingMappingOptions?.expenseAccountOptions?.forEach(
                    (element) => {
                        tempExpenseOptions.push({
                            value: element.id,
                            label: element.name,
                        });
                    }
                );
                objList?.accountingMappingOptions?.incomeAccountOptions?.forEach(
                    (element) => {
                        tempIncomeOptions.push({
                            value: element.id,
                            label: element.name,
                        });
                    }
                );
                objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
                    (element) => {
                        tempLiabilityOptions.push({
                            value: element.id,
                            label: element.name,
                        });
                    }
                );
                objList?.paymentTypeOptions?.forEach((element) => {
                    tempPaymentTypeOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                const chargesLength = objList?.charges?.length || 0;
                // console.log(chargesLength);
                setChargeTableCount(chargesLength);

                objList?.charges?.forEach((element, index) => {
                    tempCharges.push({
                        key: index + 1,
                        id: element?.id ? element?.id : "-",
                        chargeId: element?.chargeId ? element?.chargeId : "-",
                        name: element?.name ? element?.name : "-",
                        type: element?.chargeCalculationType?.value
                            ? element?.chargeCalculationType?.value
                            : "-",
                        amount: element?.amount ? (
                            <Statistic
                                value={element?.amount}
                                precision={2}
                                valueStyle={{ fontSize: "16px" }}
                            />
                        ) : (
                            0
                        ),
                        amountToUse: element.amount ? element.amount : 0,
                        collectedOn: element?.chargeTimeType?.value
                            ? element?.chargeTimeType?.value
                            : "-",
                        feeOnMonthDay: element?.feeOnMonthDay
                            ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
                            : "-",

                        feeInterval: element?.feeInterval?.value
                            ? element?.feeInterval?.value
                            : "-",
                    });
                });

                objList?.chargeOptions?.forEach((element) => {
                    tempChargesOptions.push({
                        value: element.id,
                        label: `${element.name}(${element?.currency?.name})`,
                        currencyName: element?.currency?.name,
                        currencyCode: element?.currency?.code,
                    });
                });

                objList?.penaltyOptions?.forEach((element) => {
                    tempPenaltyOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                setProductData(tempProducts);
                setFieldOfficerData(tempFieldOfficer);
                setCurrencyData(tempCurrency);
                setInterestCompoundingPeriodTypeOptions(
                    tempInterestCompoundingPeriodTypeOptions
                );
                setInterestPostingPeriodTypeOptions(
                    tempInterestPostingPeriodTypeOptions
                );
                setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
                setInterestCalculationDaysInYearTypeOptions(
                    tempInterestCalculationDaysInYearTypeOptions
                );
                setLockinPeriodFrequencyTypeOptions(
                    tempLockinPeriodFrequencyTypeOptions
                );
                // setCharges(tempCharges);
                setChargeTableSource(tempCharges);
                // setChargesOptions(tempChargesOptions);

                const chargeForTableData = tempChargesOptions.filter(
                    (item) => item.currencyCode === tempCurrency.code
                );
                useForm.setFieldsValue({
                    chargeId: "",
                });
                console.log(chargeForTableData);
                setChargesOptions([...chargeForTableData]);
                setIsLoading(false);
            }
        });
    };
    const onChangeProduct = (productParam) => {
        getCustomerProductTemplate(templateProdDetail, productParam);
    };
    const handleOverdarftAllowed = (value) => {
        // setIsOverdraftAllowed(value);
    }
    const getCustomerProductTemplate = (customerParam, productParam) => {
        const params = {
            clientId: customerParam.clientId,
            productId: productParam,
        };

        const url = `${apiConfig.SavingsAccounts}/template`;

        let body = {
            session,
            params,
        };

        setIsLoading(true);
        /** FETCH ROLE */
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            } else {
                // setTemplateProdDetail(res);
                const objList = res;
                let tempProducts = [];
                let tempFieldOfficer = [];
                let tempCurrency = objList?.currency;
                let tempInterestCompoundingPeriodTypeOptions = [];
                let tempInterestPostingPeriodTypeOptions = [];
                let tempInterestCalculationTypeOptions = [];
                let tempInterestCalculationDaysInYearTypeOptions = [];
                let tempLockinPeriodFrequencyTypeOptions = [];
                let tempPeriodFrequencyTypeOptions = [];
                let tempPreClosurePenalInterestOnTypeOptions = [];
                let tempTaxGroupOptions = [];
                let tempAssetOptions = [];
                let tempEquityOptions = [];
                let tempExpenseOptions = [];
                let tempIncomeOptions = [];
                let tempLiabilityOptions = [];
                let tempCharges = [];
                let tempChargesOptions = [];
                let tempPenaltyOptions = [];
                let tempPaymentTypeOptions = [];

                // console.log(objList);

                useForm.setFieldsValue({
                    productId: objList.savingsProductId,
                    fieldOfficerId: objList.fieldOfficerId,
                    submittedOnDate: objList?.timeline
                        ? dayjs(BOM.FormatArrayDate(objList?.timeline?.submittedOnDate))
                        : objList?.timeline?.submittedOnDate,
                    nominalAnnualInterestRate: objList?.nominalAnnualInterestRate,
                    interestCompoundingPeriodType:
                        objList?.interestCompoundingPeriodType?.id,
                    interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
                    interestCalculationType: objList?.interestCalculationType?.id,
                    interestCalculationDaysInYearType:
                        objList?.interestCalculationDaysInYearType?.id,
                    minRequiredOpeningBalance: objList?.minRequiredOpeningBalance,
                    lockinPeriodFrequency: objList?.lockinPeriodFrequency,
                    lockinPeriodFrequencyType: objList?.lockinPeriodFrequencyType?.id,
                    lienAllowed: objList?.lienAllowed,
                    maxAllowedLienLimit: objList?.maxAllowedLienLimit,
                    enforceMinRequiredBalance: objList?.enforceMinRequiredBalance,
                    minRequiredBalance: objList?.minRequiredBalance,
                    withdrawalFeeForTransfers: objList?.withdrawalFeeForTransfers,
                });

                objList?.productOptions?.forEach((element) => {
                    tempProducts.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.fieldOfficerOptions?.forEach((element) => {
                    tempFieldOfficer.push({
                        value: element.id,
                        label: element.displayName,
                    });
                });

                objList?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
                    tempInterestCompoundingPeriodTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.interestPostingPeriodTypeOptions?.forEach((element) => {
                    tempInterestPostingPeriodTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.interestCalculationTypeOptions?.forEach((element) => {
                    tempInterestCalculationTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.interestCalculationDaysInYearTypeOptions?.forEach(
                    (element) => {
                        tempInterestCalculationDaysInYearTypeOptions.push({
                            value: element.id,
                            label: element.value,
                        });
                    }
                );
                objList?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
                    tempLockinPeriodFrequencyTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.periodFrequencyTypeOptions?.forEach((element) => {
                    tempPeriodFrequencyTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
                    tempPreClosurePenalInterestOnTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objList?.taxGroupOptions?.forEach((element) => {
                    tempTaxGroupOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });
                objList?.accountingMappingOptions?.assetAccountOptions?.forEach(
                    (element) => {
                        tempAssetOptions.push({
                            value: element.id,
                            label: element.name,
                        });
                    }
                );
                objList?.accountingMappingOptions?.equityAccountOptions?.forEach(
                    (element) => {
                        tempEquityOptions.push({
                            value: element.id,
                            label: element.name,
                        });
                    }
                );
                objList?.accountingMappingOptions?.expenseAccountOptions?.forEach(
                    (element) => {
                        tempExpenseOptions.push({
                            value: element.id,
                            label: element.name,
                        });
                    }
                );
                objList?.accountingMappingOptions?.incomeAccountOptions?.forEach(
                    (element) => {
                        tempIncomeOptions.push({
                            value: element.id,
                            label: element.name,
                        });
                    }
                );
                objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
                    (element) => {
                        tempLiabilityOptions.push({
                            value: element.id,
                            label: element.name,
                        });
                    }
                );
                objList?.paymentTypeOptions?.forEach((element) => {
                    tempPaymentTypeOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                const chargesLength = objList?.charges?.length || 0;
                // console.log(chargesLength);
                setChargeTableCount(chargesLength);

                objList?.charges?.forEach((element, index) => {
                    tempCharges.push({
                        key: index + 1,
                        id: element?.id ? element?.id : "-",
                        chargeId: element?.chargeId ? element?.chargeId : "-",
                        name: element?.name ? element?.name : "-",
                        type: element?.chargeCalculationType?.value
                            ? element?.chargeCalculationType?.value
                            : "-",
                        amount: element?.amount ? (
                            <Statistic
                                value={element?.amount}
                                precision={2}
                                valueStyle={{ fontSize: "16px" }}
                            />
                        ) : (
                            0
                        ),
                        amountToUse: element.amount ? element.amount : 0,
                        collectedOn: element?.chargeTimeType?.value
                            ? element?.chargeTimeType?.value
                            : "-",
                        feeOnMonthDay: element?.feeOnMonthDay
                            ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
                            : "-",

                        feeInterval: element?.feeInterval?.value
                            ? element?.feeInterval?.value
                            : "-",
                    });
                });

                objList?.chargeOptions?.forEach((element) => {
                    tempChargesOptions.push({
                        value: element.id,
                        label: `${element.name}(${element?.currency?.name})`,
                        currencyName: element?.currency?.name,
                        currencyCode: element?.currency?.code,
                    });
                });

                objList?.penaltyOptions?.forEach((element) => {
                    tempPenaltyOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                setProductData(tempProducts);
                setFieldOfficerData(tempFieldOfficer);
                setCurrencyData(tempCurrency);
                setInterestCompoundingPeriodTypeOptions(
                    tempInterestCompoundingPeriodTypeOptions
                );
                setInterestPostingPeriodTypeOptions(
                    tempInterestPostingPeriodTypeOptions
                );
                setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
                setInterestCalculationDaysInYearTypeOptions(
                    tempInterestCalculationDaysInYearTypeOptions
                );
                setLockinPeriodFrequencyTypeOptions(
                    tempLockinPeriodFrequencyTypeOptions
                );
                // setCharges(tempCharges);
                setChargeTableSource(tempCharges);
                // setChargesOptions(tempChargesOptions);

                const chargeForTableData = tempChargesOptions.filter(
                    (item) => item.currencyCode === tempCurrency.code
                );
                useForm.setFieldsValue({
                    chargeId: "",
                });
                // console.log(chargeForTableData);
                setChargesOptions([...chargeForTableData]);
                setIsLoading(false);
            }
        });
    };
    function onCancel() {
        navigate("/detail-group-savings", { state: state });
    }
    const handleFieldOfficerChange = (value) => {
        if (!value) {
            setFieldOfficerIsEmpty(null);
        }
    };
    const handleChargeDelete = (key) => {
        let action = "Delete  ";
        let label = BOM.SubstringFormat(key.name, 20);

        Notiflix.Confirm.show(
            "Are you sure?",
            action + label,
            "Yes",
            "No",

            function () {
                const newData = chargeTableSource.filter((item) => item.id !== key.id);
                setChargeTableSource(newData);
            },

            function () {
                // No button
            }
        );
    };
    const columns = [
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Type",
            dataIndex: "type",
        },
        {
            title: "Amount",
            dataIndex: "amount",
        },
        {
            title: "Collected On",
            dataIndex: "collectedOn",
        },
        {
            title: "Date",
            dataIndex: "feeOnMonthDay",
        },
        {
            title: "Repayments Every",
            dataIndex: "feeInterval",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) =>
                chargeTableSource.length >= 1 ? (
                    <Tooltip title={`Remove Charge`}>
                        <Button
                            type="primary"
                            icon={<DeleteOutlined />}
                            onClick={() => handleChargeDelete(record)}
                            shape="round"
                            size="small"
                            className="of-primaryBtnColor"
                        />
                    </Tooltip>
                ) : null,
        },
    ];
    const onSubmit = (formValues) => {

        let tempChargeArray = [];
        chargeTableSource.forEach((element, index) => {
            if (element.feeOnMonthDay === "-") {
                tempChargeArray.push({
                    chargeId: element.chargeId,
                    amount: element.amountToUse,
                });
            } else {
                tempChargeArray.push({
                    chargeId: element.chargeId,
                    amount: element.amountToUse,
                    feeOnMonthDay: BOM.DateTimeWithoutYear(
                        element.feeOnMonthDay,
                        "only-date"
                    ),
                });
            }
        });

        formValues.submittedOnDate = formValues.submittedOnDate
            ? BOM.DateTime(formValues.submittedOnDate, "only-date")
            : formValues.submittedOnDate;
        formValues.clientId = templateProdDetail.clientId;
        formValues.allowOverdraft = false;
        formValues.fieldOfficerId = fieldOfficerIsEmpty === null ? fieldOfficerIsEmpty : formValues.fieldOfficerId
        formValues.charges = tempChargeArray;
        formValues.dateFormat = "dd MMMM yyyy";
        formValues.monthDayFormat = "dd MMMM";
        formValues.locale = "en";

        delete formValues.chargeId;

        const url = `${apiConfig.SavingsAccounts}/${state.id}`;

        const body = {
            ...formValues,
            method: "PUT",
            session,
        };
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.modifySavingsGrpAppMsg);
                navigate("/detail-group-savings", {
                    state: { ...state, statusValue: accountStatus.submittedAndPending },
                });
                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <MainLayout isEnableRightSidebar={true}>
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent pageTitle={"Edit Saving Account"} pageItems={[]} />
            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                >
                    <Form
                        initialValues={{
                            active: true,
                            isPenalty: false,
                        }}
                        form={useForm}
                        layout="vertical"
                        onFinish={onSubmit}
                    >
                        <Row>
                            <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                                {"Savings Account Setup"}
                            </Title>
                        </Row>
                        <Divider style={{ marginTop: 10, marginBottom: 30 }} />
                        <Row>
                            <Divider orientation="left" orientationMargin="0">
                                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                    {labelConfig.generalInfo}
                                </Title>
                            </Divider>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.product}
                                    name={"productId"}
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.product),
                                        },
                                    ]}
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.product,
                                            "select"
                                        )}
                                        options={productData}
                                        showSearch
                                        onChange={onChangeProduct}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.accountOfficer}
                                    name={"fieldOfficerId"}
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.accountOfficer,
                                            "select"
                                        )}
                                        options={fieldOfficerData}
                                        onChange={handleFieldOfficerChange}
                                        allowClear
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item label={labelConfig.currency}>
                                    <Input
                                        disabled
                                        className="of-bold-disable-input"
                                        value={`${currencyData.name ? currencyData.name : ""}${currencyData.code ? ` (${currencyData.code})` : " - "
                                            }`}
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.currency)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item label={labelConfig.decimalPlaces}>
                                    <Input
                                        disabled
                                        className="of-bold-disable-input"
                                        value={`${currencyData.decimalPlaces
                                            ? currencyData.decimalPlaces
                                            : "-"
                                            }`}
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.decimalPlaces
                                        )}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item label={labelConfig.currencyInMultiplesOf}>
                                    <Input
                                        disabled
                                        className="of-bold-disable-input"
                                        value={`${currencyData.inMultiplesOf
                                            ? currencyData.inMultiplesOf
                                            : " - "
                                            }`}
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.currencyInMultiplesOf
                                        )}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.submittedOn}
                                    name="submittedOnDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.submittedOn),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        disabledDate={BOM.DisabledAfterCurrentDate}
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.submittedDate,
                                            "select"
                                        )}
                                        style={{ width: "100%", height: 35 }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={<Text>{labelConfig.externalID}</Text>}
                                    name="externalId"
                                >
                                    <Input placeholder="External ID" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Divider orientation="left" orientationMargin="0">
                                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                    {labelConfig.interestInformation}
                                </Title>
                            </Divider>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.nominalAnnualInterest}
                                    name={"nominalAnnualInterestRate"}
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                labelConfig.nominalAnnualInterest
                                            ),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.nominalAnnualInterest
                                        )}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.interestCompoundingPeriod}
                                    name={"interestCompoundingPeriodType"}
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                labelConfig.interestCompoundingPeriod
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.interestCompoundingPeriod,
                                            "select"
                                        )}
                                        options={interestCompoundingPeriodTypeOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.interestPostingPeriod}
                                    name={"interestPostingPeriodType"}
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                labelConfig.interestPostingPeriod
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.interestPostingPeriod,
                                            "select"
                                        )}
                                        options={interestPostingPeriodTypeOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.interestCalculatedUsing}
                                    name={"interestCalculationType"}
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                labelConfig.interestCalculatedUsing
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.interestCalculatedUsing,
                                            "select"
                                        )}
                                        options={interestCalculationTypeOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.daysInYear}
                                    name={"interestCalculationDaysInYearType"}
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.daysInYear),
                                        },
                                    ]}
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.daysInYear,
                                            "select"
                                        )}
                                        options={interestCalculationDaysInYearTypeOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            <Divider orientation="left" orientationMargin="0">
                                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                    {labelConfig.additionalInfo}
                                </Title>
                            </Divider>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.minimumOpeningBalance}
                                    name={"minRequiredOpeningBalance"}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.minimumOpeningBalance
                                        )}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.lockInPeriod}
                                    name={"lockinPeriodFrequency"}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.lockInPeriod
                                        )}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item label={labelConfig.lockInPeriodType}
                                    name={"lockinPeriodFrequencyType"}>
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.lockInPeriod,
                                            "select"
                                        )}
                                        options={lockinPeriodFrequencyTypeOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.isLienAllowed}
                                    name={"lienAllowed"}
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.isLienAllowed,
                                            "select"
                                        )}
                                        options={staticConfig.yesOrNoData}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            {isLienAllowed && (
                                <Col span={8} style={{ padding: "0px 8px" }}>
                                    <Form.Item
                                        label={labelConfig.maxLienAmtLimit}
                                        name={"maxAllowedLienLimit"}
                                    >
                                        <Input
                                            placeholder={BOM.handlePlaceholderMsg(
                                                labelConfig.maxLienAmtLimit
                                            )}
                                        />
                                    </Form.Item>
                                </Col>
                            )}
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.minimumBalance}
                                    name={"minRequiredBalance"}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.minimumBalance
                                        )}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.applyWithdrawalFeeForTransfers}
                                    name={"withdrawalFeeForTransfers"}
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.applyWithdrawalFeeForTransfers,
                                            "select"
                                        )}
                                        options={staticConfig.yesOrNoData}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.isOverdraftAllowed}
                                    name="allowOverdraft"
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.isOverdraftAllowed,
                                            "select"
                                        )}
                                        options={staticConfig.yesOrNoData}
                                        onChange={handleOverdarftAllowed}
                                    />
                                </Form.Item>
                            </Col>
                            {isOverdraftAllowed && (
                                <>
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={labelConfig.maxOverdraftAmtLimit}
                                            name="overdraftLimit"
                                        >
                                            <Input
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    labelConfig.maxOverdraftAmtLimit
                                                )}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={
                                                <Tooltip
                                                    title={labelConfig.nominalAnnualIntrstForOverdraft}
                                                >
                                                    {BOM.SubstringFormat(
                                                        labelConfig.nominalAnnualIntrstForOverdraft,
                                                        20
                                                    )}
                                                </Tooltip>
                                            }
                                            name="nominalAnnualInterestRateOverdraft"
                                        >
                                            <Input
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    labelConfig.nominalAnnualIntrstForOverdraft
                                                )}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={
                                                <Tooltip
                                                    title={labelConfig.minOverdraftForIntrstCalc}
                                                >
                                                    {BOM.SubstringFormat(
                                                        labelConfig.minOverdraftForIntrstCalc,
                                                        20
                                                    )}
                                                </Tooltip>
                                            }
                                            name="minOverdraftForInterestCalculation"
                                        >
                                            <Input
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    labelConfig.minOverdraftForIntrstCalc
                                                )}
                                            />
                                        </Form.Item>
                                    </Col>
                                </>
                            )}
                        </Row>

                        <Divider orientation="left" orientationMargin="0">
                            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                {labelConfig.chargeInfo}
                            </Title>
                        </Divider>
                        <ChargeModal
                            formData={formData}
                            isModalOpen={isModalOpen}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            setIsModalOpen={setIsModalOpen}
                            chargeData={chargesOptions}
                            setChargeList={setChargeList}
                            setChargeTableSource={setChargeTableSource}
                            chargeTableSource={chargeTableSource}
                            chargeList={chargeList}
                            session={session}
                        />

                        <Divider orientation="left" orientationMargin="0">
                            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                {chargeTableSource.length > 1
                                    ? labelConfig.selectedCharges
                                    : labelConfig.selectedCharge}
                            </Title>
                        </Divider>

                        {chargeTableSource?.length > 0 && (
                            <Table
                                columns={columns}
                                dataSource={chargeTableSource}
                                bordered
                                pagination={{
                                    position: "bottomCentre",
                                    pageSize: "10",
                                }}
                            />
                        )}

                        <Row>
                            <Divider />
                            <CustomButton
                                content="Submit"
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#92428B"
                                colorText="white"
                                hoverBackground="#AD4EA7"
                            />
                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>
                </Card>
            </Spin>
        </MainLayout>
    );
};
export default ModifyApplication;

const ChargeModal = (props) => {
    const {
        session,
        isLoading,
        setIsLoading,
        setChargeTableSource,
        chargeTableSource,
        isModalOpen,
        chargeData,
        setIsModalOpen,
        setChargeList,
        chargeList,
    } = props;

    const [useForm] = Form.useForm();

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleChargeSave = (formValues) => {

        const newCharges = {
            // key: formValues?.chargeId,
            key: formValues?.chargeId,
            id: formValues?.chargeId,
            chargeId: formValues?.chargeId,
            name: formValues.name,
            type: formValues.type,
            collectedOn: formValues.collectedOn,
            amountToUse: formValues?.amount,
            amount: (
                <Statistic
                    value={formValues?.amount}
                    precision={2}
                    valueStyle={{ fontSize: "16px" }}
                />
            ),
            feeOnMonthDay: formValues.feeOnMonthDay
                ? BOM.DateTimeWithoutYear(formValues.feeOnMonthDay, "only-date")
                : "-",
            feeInterval: formValues.feeInterval ? formValues.feeInterval : "-",
        };

        let foundCharge = chargeTableSource.find(
            (item) => item.chargeId === newCharges?.chargeId
        );
        if (foundCharge) {
            BOM.AlertMsg(cnt.WARNING, "No duplicate Charge allowed!");
            return;
        }
        setChargeTableSource([...chargeTableSource, newCharges]);

        useForm.resetFields();
    };

    const handleSelectedCharge = (chargeId) => {
        const params = {
            template: "true",
        };

        const url = `${apiConfig.Charges}/${chargeId}`;

        const body = {
            session,
            params,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            } else {
                const objList = res;

                useForm.setFieldsValue({
                    key: objList.id,
                    id: objList.id,
                    name: objList.name,
                    type: objList.chargeCalculationType.value,
                    collectedOn: objList?.chargeTimeType.value,
                    amount: objList?.amount,
                    feeOnMonthDay: objList?.feeOnMonthDay
                        ? dayjs(BOM.FormatArrayDateWithoutYear(objList?.feeOnMonthDay))
                        : objList?.feeOnMonthDay,
                    feeInterval: objList?.feeInterval,
                });

                // STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <Row>
            <Button
                type="primary"
                onClick={showModal}
                icon={<PlusOutlined />}
                style={{
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    backgroundColor: "#92428B",
                    marginBottom: 20,
                }}
            >
                {labelConfig.addCharge}
            </Button>

            <Modal
                title="Charge Information Setup"
                open={isModalOpen}
                okText="Add"
                cancelText="Cancel"
                okButtonProps={{
                    autoFocus: true,
                    htmlType: "submit",
                    style: {
                        ...styles.ofPrimaryBtnColor,
                    },
                }}
                centered
                onCancel={handleCancel}
                width={800}
                modalRender={(dom) => (
                    <Form
                        form={useForm}
                        layout="vertical"
                        onFinish={handleChargeSave}
                        name="address-info"
                    >
                        {dom}
                    </Form>
                )}
                style={{
                    height: 600,
                    overflow: "auto",
                }}
            >
                <Spin spinning={isLoading} tip="Loading..." size="large">
                    <Row>
                        <Divider />

                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                name={"chargeId"}
                                label={"Charge Options"}
                                rules={[
                                    {
                                        required: true,
                                        message: BOM.CheckReqFld(labelConfig.charge),
                                    },
                                ]}
                            >
                                <Select
                                    filterOption={(input, option) =>
                                        (option?.label?.toLowerCase() ?? "").includes(
                                            input?.toLowerCase()
                                        )
                                    }
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.charge,
                                        "select"
                                    )}
                                    options={chargeData}
                                    onChange={handleSelectedCharge}
                                    style={{ width: "30vh" }}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Divider />
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.name} name={"name"}>
                                <Input
                                    disabled
                                    className="of-bold-disable-input"
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.type} name={"type"}>
                                <Input
                                    disabled
                                    className="of-bold-disable-input"
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.collectedOn} name={"collectedOn"}>
                                <Input
                                    disabled
                                    className="of-bold-disable-input"
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.collectedOn
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.amount} name={"amount"}>
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.date} name={"feeOnMonthDay"}>
                                <DatePicker
                                    disabledDate={BOM.DisabledAfterCurrentDate}
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.date,
                                        "select"
                                    )}
                                    style={{ width: "100%", height: 35 }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.repaymentsEvery}
                                name={"feeInterval"}
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.repaymentsEvery
                                    )}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* </Form> */}
                </Spin>
            </Modal>
        </Row>
    );
};
